module.exports = [{
  plugin: require('../../@mdx-deck/gatsby-plugin/gatsby-browser.js'),
  options: {
    "plugins": [],
    "path": "/opt/build/repo/slides/deck.mdx",
    "dirname": "/opt/build/repo/slides"
  }
}];